import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import { forwardRef } from 'react';
import { useId } from '@equinor/eds-utils';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { InputWrapper } from '../InputWrapper/InputWrapper.js';
import { Textarea } from '../Textarea/Textarea.js';
import { Input } from '../Input/Input.js';

var _excluded = ["id", "label", "meta", "unit", "helperText", "placeholder", "disabled", "multiline", "className", "variant", "inputIcon", "helperIcon", "style", "rowsMax", "textareaRef", "inputRef"];
/** Proxy component for working around typescript and element type switching */
var Field = /*#__PURE__*/forwardRef(function Field(props, ref) {
  return props.$multiline ? /*#__PURE__*/jsx(Textarea, _objectSpread({
    ref: ref
  }, props)) : /*#__PURE__*/jsx(Input, _objectSpread({
    ref: ref
  }, props));
});
var TextField = /*#__PURE__*/forwardRef(function TextField(_ref, ref) {
  var id = _ref.id,
    label = _ref.label,
    meta = _ref.meta,
    unit = _ref.unit,
    helperText = _ref.helperText,
    placeholder = _ref.placeholder,
    disabled = _ref.disabled,
    _ref$multiline = _ref.multiline,
    multiline = _ref$multiline === void 0 ? false : _ref$multiline,
    className = _ref.className,
    variant = _ref.variant,
    inputIcon = _ref.inputIcon,
    helperIcon = _ref.helperIcon,
    style = _ref.style,
    rowsMax = _ref.rowsMax,
    textareaRef = _ref.textareaRef,
    inputRef = _ref.inputRef,
    other = _objectWithoutProperties(_ref, _excluded);
  var helperTextId = useId(null, 'helpertext');
  var fieldProps = _objectSpread({
    'aria-invalid': variant === 'error' || undefined,
    disabled: disabled,
    placeholder: placeholder,
    id: id,
    variant: variant,
    rightAdornments: /*#__PURE__*/jsxs(Fragment, {
      children: [inputIcon, /*#__PURE__*/jsx("span", {
        children: unit
      })]
    }),
    rowsMax: rowsMax,
    ref: inputRef || textareaRef,
    $multiline: multiline
  }, other);
  var helperProps = {
    id: null,
    text: helperText,
    icon: helperIcon,
    disabled: disabled
  };
  var containerProps = {
    ref: ref,
    className: className,
    style: _objectSpread({
      width: '100%'
    }, style),
    color: variant
  };
  var labelProps = {
    htmlFor: id,
    label: label,
    meta: meta,
    disabled: disabled
  };
  if (helperText) {
    fieldProps = _objectSpread({
      'aria-describedby': helperTextId
    }, fieldProps);
    helperProps = _objectSpread(_objectSpread({}, helperProps), {}, {
      id: helperTextId
    });
  }
  return /*#__PURE__*/jsx(InputWrapper, _objectSpread(_objectSpread({
    helperProps: helperProps,
    labelProps: labelProps
  }, containerProps), {}, {
    children: /*#__PURE__*/jsx(Field, _objectSpread({}, fieldProps))
  }));
});

export { TextField };
